import React, { Fragment, useEffect, useState } from "react";
import { useSnackbar, useTranslation } from "@1f/react-sdk";
import sharedDatas from "../businessLogic/sharedDatas";

//Vapor Components
import Stack from "@vapor/react-material/Stack";
import Box from "@vapor/react-material/Box";
import Button from "@vapor/react-material/Button";
import DataGrid from "@vapor/react-x-data-grid/DataGrid"
import Modal from "@vapor/react-material/Modal";
import Divider from "@vapor/react-material/Divider";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import Tooltip from "@vapor/react-material/Tooltip";
import Skeleton from "@mui/material/Skeleton";

//Style
import { modalStyleUltraLarge } from "../businessLogic/styles";
import UserApi from "../businessLogic/api/userApi";
import { LogApi } from "../businessLogic/api/logApi";

export const ModalSearchResultList = ({ show, onClose, onOk,anagToShowList }) => { 
    const { t } = useTranslation();
    const [dataRows,setDataRows] = useState([])     
    const [selectedItemId,setSelectedItemId] = useState([])
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const aziendaId = sharedDatas.getPropertyByName("aziendaId");
    const userApi = UserApi()
    const logApi = LogApi()

    const [dataColumns] = useState([
        {field: "id", hideable: true},
        {
            field: "nome", 
            minWidth: 250,
            renderCell: (params) =>
                params.row.isDisabled ? (
                    <Tooltip title={params.row.identificatoreAssente ? "Non è possibile aggiungere questa anagrafica: identificatore non disponibile" : `Non è possibile aggiungere questa anagrafica che risulta essere stata identificata da ${params.row.identifiedBy} che non ha i necessari permessi per il soggetto obbligato corrente ${params.row.aziendaName}`}>
                        <span style={{ width: "100%", display: "block" }}>{params.value}</span>
                    </Tooltip>
                ) : (
                    params.value
                )    
        },
        {
            field: "cognome", 
            minWidth: 250,
            renderCell: (params) =>
                params.row.isDisabled ? (
                    <Tooltip title={params.row.identificatoreAssente ? "Non è possibile aggiungere questa anagrafica: identificatore non disponibile" : `Non è possibile aggiungere questa anagrafica che risulta essere stata identificata da ${params.row.identifiedBy} che non ha i necessari permessi per il soggetto obbligato corrente ${params.row.aziendaName}`}>
                        <span style={{ width: "100%", display: "block" }}>{params.value}</span>
                    </Tooltip>
                ) : (
                    params.value
                )    
        },
        {
            field: "cf",
            headerName:"Codice Fiscale",    
            minWidth: 250,
            renderCell: (params) =>
                params.row.isDisabled ? (
                    <Tooltip title={params.row.identificatoreAssente ? "Non è possibile aggiungere questa anagrafica: identificatore non disponibile" : `Non è possibile aggiungere questa anagrafica che risulta essere stata identificata da ${params.row.identifiedBy} che non ha i necessari permessi per il soggetto obbligato corrente ${params.row.aziendaName}`}>
                        <span style={{ width: "100%", display: "block" }}>{params.value}</span>
                    </Tooltip>
                ) : (
                    params.value
                )            
        }
    ])

    useEffect(() => {   
        loadDatas();        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [anagToShowList]);

    async function loadDatas() {
        try {
            setLoading(true);
            const professionistiAzienda = await userApi.GetUsersByCompanyId();        
            let anagListPromises = anagToShowList.map(async (item) => {                        
                const identificatoreAssente = !item.identifiedByUser?.trim();
                let anagInAzienda = !professionistiAzienda.some(f=> f.userId === item.identifiedByUser)
                let userName = "";
                if(!identificatoreAssente && anagInAzienda){
                    const { userResponse } = await userApi.GetUserById(item.identifiedByUser);
                    userName = [userResponse?.Name, userResponse?.Surname].filter(Boolean).join(" ");
                }
                return {
                    id: item.id,
                    nome: item.nome,
                    cognome: item.cognome,
                    cf: item.cf,
                    isDisabled : identificatoreAssente || anagInAzienda,
                    identificatoreAssente,
                    identifiedBy: userName,
                    aziendaName: sharedDatas.getPropertyByName("aziendaModelList").filter(x => x.id === aziendaId)[0].denominazione
                };
            });     
            const anagList = await Promise.all(anagListPromises);
            setDataRows(anagList);
        } catch (error) {
            logApi.AddLog(error.message, error.stack, "loadDatas", "ModalSearchResultList");
            enqueueSnackbar(t("errors.genericError"), { variant: "error" });
        } finally {
            setLoading(false);
        }        
    }
    //Actions
    const handleModalClose = (e) => {
        onClose(e);
    };
    const handleModalOk = (e,selectedItem) => {
        onOk(e,selectedItem);
    };
    const handleSelectedRow = (selItem,e) => {
        setSelectedItemId(selItem[0])
    };

    return (
        <Fragment>
        <Modal
            key="searchResultModal"
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            open={show}
            onClose={handleModalClose}
            onBackdropClick={handleModalClose}
        >
            <Box sx={modalStyleUltraLarge}>
                <Stack
                    direction="column"
                    spacing={0}
                    justifyContent="left"
                    alignItems="left"
                >
                    <ExtendedTypography
                        variant="titleSmall"
                        color="primary.main"
                        sx={{ p: 2, pl: 3 }}
                    >
                        Risultati della ricerca
                    </ExtendedTypography>
                    <Divider
                        orientation="horizontal"
                        flexItem                       
                    />                            
                </Stack>

                {loading ? (
                    <Box sx={{ width: "100%" }}>                         
                        <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
                            <Skeleton variant="text" width={250} />
                            <Skeleton variant="text" width={250} />
                            <Skeleton variant="text" width={250} />                    
                        </Stack>
                        {[...Array(5)].map((_, rowIdx) => (
                        <Stack direction="row" spacing={1} key={rowIdx} sx={{ mb: 1 }}>
                            {[...Array(3)].map((_, colIdx) => (
                            <Skeleton
                                key={colIdx}
                                variant="rectangular"
                                height={50}
                                width={250}
                                animation="wave"
                            />
                            ))}
                        </Stack>
                        ))}
                    </Box>                  
                ) : (                    
                    dataRows.length > 0 &&
                        <DataGrid
                            columns={dataColumns}
                            rows={dataRows}
                            getRowId={(row) => row.id}
                            isRowSelectable={(params) => !params.row.isDisabled}                                       
                            getRowClassName={(params) => params.row.isDisabled ? 'row-disabled' : ''}
                            autoHeight={true}   
                            pageSizeOptions={[10]}                    
                            pagination
                            disableSelectionOnClick
                            onRowSelectionModelChange={(row,event) => handleSelectedRow(row,event)}
                            initialState={{
                            columns: {
                                columnVisibilityModel: {
                                    id: false,
                                },
                            },
                            pagination: {
                                paginationModel: {
                                pageSize: 25,
                                },
                            },
                            }}
                        />               
                )}

                <Stack
                    direction="row"
                    spacing={1}
                    sx={{ p: 1, mt: 1, bgcolor: "#F2F5F8" }}
                    justifyContent="right"
                    alignItems="right"
                >
                    <Button variant="outlined" size="small" onClick={handleModalClose}>
                        {t("actions.annulla")}
                    </Button>
                    <Button variant="contained" size="small" onClick={(evt) => handleModalOk(evt,selectedItemId)} disabled={selectedItemId.length === 0}>
                        Seleziona
                    </Button>
            </Stack>
            </Box>
        </Modal>
        </Fragment>
    );
};
